var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('img',{attrs:{"src":_vm.header.logo}}),_c('div',{staticClass:"bm-header"},[_c('small',{domProps:{"innerHTML":_vm._s(_vm.header.copy)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }